"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Formatrpt603CPPTMembersXL = exports.rpt603CPPTMembersXL = exports.Formatrpt603CPPTXL = exports.rpt603CPPTXL = void 0;
const DAY_MS = 24 * 60 * 60 * 1000;
const parseDate = (value) => {
    if (!value) {
        return null;
    }
    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
};
const rpt603CPPTXL = () => {
    const retVal = [];
    retVal.push(['Event Manager RPT 60-3 CPPT Status Report']);
    retVal.push(['This document was generated on: ', '', '', Date.now()]);
    retVal.push([]);
    return retVal;
};
exports.rpt603CPPTXL = rpt603CPPTXL;
const Formatrpt603CPPTXL = (sheet) => {
    const dateFormat = 'mm/dd/yyyy hh:mm';
    const dateWidth = dateFormat.length;
    sheet['!merges'] = [
        { s: { c: 0, r: 0 }, e: { c: 5, r: 0 } },
        { s: { c: 0, r: 1 }, e: { c: 2, r: 1 } },
    ];
    sheet.D2.t = 'd';
    sheet.D2.z = dateFormat;
    sheet['!cols'] = [
        { width: 16 },
        { width: 28 },
        { width: 12 },
        { wch: dateWidth },
        { wch: dateWidth },
        { wch: dateWidth },
    ];
    return sheet;
};
exports.Formatrpt603CPPTXL = Formatrpt603CPPTXL;
const rpt603CPPTMembersXL = (memberStatuses) => {
    const generatedAt = new Date();
    const todayMidnight = new Date(generatedAt.getFullYear(), generatedAt.getMonth(), generatedAt.getDate()).getTime();
    const expiringSoonThreshold = todayMidnight + 30 * DAY_MS;
    const retVal = [];
    const row = [
        'Member Type',
        'Full Name',
        'CAPID',
        'CPPT Completion Date',
        'CPPT Expiration Date',
    ];
    const widths = [...row.map(item => item.length)];
    retVal.push(row);
    for (const item of [...memberStatuses].sort((a, b) => `${a.nameLast}, ${a.nameFirst}`.localeCompare(`${b.nameLast}, ${b.nameFirst}`))) {
        const completionDate = parseDate(item.cpptCompletionDate);
        const expirationDate = completionDate ? new Date(completionDate.getTime()) : null;
        if (expirationDate) {
            expirationDate.setFullYear(expirationDate.getFullYear() + 1);
        }
        const expirationTime = expirationDate
            ? new Date(expirationDate.getFullYear(), expirationDate.getMonth(), expirationDate.getDate()).getTime()
            : Number.NEGATIVE_INFINITY;
        const isExpired = expirationTime < todayMidnight;
        const isExpiringSoon = !isExpired && expirationTime <= expiringSoonThreshold;
        const nameCell = {
            v: `${item.memberRank} ${item.nameLast}, ${item.nameFirst}`,
        };
        if (isExpired) {
            nameCell.s = {
                fill: { fgColor: { rgb: 'FFC7CE' } },
                font: { color: { rgb: '9C0006' }, bold: true },
            };
        }
        else if (isExpiringSoon) {
            nameCell.s = {
                fill: { fgColor: { rgb: 'FFEB9C' } },
                font: { color: { rgb: '9C6500' }, bold: true },
            };
        }
        const currentRow = [
            item.memberType,
            nameCell,
            item.capid,
            item.cpptCompletionDate,
            expirationDate ? expirationDate.toISOString().substring(0, 10) : '',
        ];
        for (let i = 0; i < currentRow.length; i++) {
            if (typeof currentRow[i] === 'object' && currentRow[i] !== null && typeof currentRow[i] === 'object' && 'v' in currentRow[i]) {
                widths[i] = Math.max(widths[i], currentRow[i].v.toString().length);
            }
            else {
                widths[i] = Math.max(widths[i], currentRow[i].toString().length);
            }
        }
        retVal.push(currentRow);
    }
    return [retVal, widths];
};
exports.rpt603CPPTMembersXL = rpt603CPPTMembersXL;
const Formatrpt603CPPTMembersXL = (sheet, widths, rowCount) => {
    sheet['!cols'] = widths.map(width => ({ width: width + 2 }));
    for (let i = 2; i <= rowCount; i++) {
        const cpptCell = sheet[`D${i}`];
        const expirationCell = sheet[`E${i}`];
        if (cpptCell && cpptCell.v) {
            cpptCell.t = 'd';
            cpptCell.z = 'mm/dd/yyyy';
        }
        if (expirationCell && expirationCell.v) {
            expirationCell.t = 'd';
            expirationCell.z = 'mm/dd/yyyy';
        }
    }
    return sheet;
};
exports.Formatrpt603CPPTMembersXL = Formatrpt603CPPTMembersXL;
//# sourceMappingURL=rpt603cppt.js.map